
// export const apiUrl ="http://localhost:1025/";
// export const apiAsset ="http://localhost:1025/uploads/";

export const apiUrl ="https://assistant.bordarna.ir/";
export const apiAsset ="https://assistant.bordarna.ir/";
// export const apiAsset ="https://api.amirhosseinmofid.ir/uploads/";
